export default __webpack_public_path__ + "static/media/bg-money-sml.b0af0696.png";